import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import classes from "./ViewMedicationTemplate.module.scss";
import { currentMedicationTemplateSelector } from "../../../redux/selectors/treatmentPlansSelector";
import { DELETE_MEDICATION_TEMPLATE_REQUEST, GET_MEDICATION_TEMPLATE_REQUEST } from "../../../redux/actions";
import { FullPageContainer } from "../../common/FullPageContainer/FullPageContainer";
import { ViewMedicationTemplateControls } from "./components/ViewMedicationTemplateControls/ViewMedicationTemplateControls";
import { ViewMedicationTemplateDetails } from "./components/ViewMedicationTemplateDetails/ViewMedicationTemplateDetails";
import { ViewMedicationTemplateTimeline } from "./components/ViewMedicationTemplateTimeline/ViewMedicationTemplateTimeline";
import { Modal } from "../../common/Modal/Modal";

export const ViewMedicationTemplate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const id = location.pathname.split("/").pop() || "";

  useEffect(() => {
    dispatch({
      type: GET_MEDICATION_TEMPLATE_REQUEST,
      payload: { id }
    });
  }, [dispatch, id]);

  const currentTemplate = useSelector(currentMedicationTemplateSelector);

  const goToTemplates = () => navigate("/medication-templates");

  const editTemplate = () => navigate(`/medication-templates/edit/${id}`);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const deleteTemplate = () => {
    dispatch({
      type: DELETE_MEDICATION_TEMPLATE_REQUEST,
      payload: { id, navigate, shouldLoadList: false }
    });
    closeModal();
  };

  return (
    <FullPageContainer pageClassName={classes.viewTemplatesContainer}>
      <>
        <ViewMedicationTemplateControls
          deleteTemplate={openModal}
          editTemplate={editTemplate}
          navigateBack={goToTemplates}
        />
        <ViewMedicationTemplateDetails template={currentTemplate} />
        <ViewMedicationTemplateTimeline medications={currentTemplate?.items} />
        <Modal
          deleteConfirmation
          open={open}
          title={"Delete template"}
          message={"Are you sure you want to delete this treatment plan?"}
          handleConfirm={deleteTemplate}
          handleCancel={closeModal}
        />
      </>
    </FullPageContainer>
  );
};
